import { render, staticRenderFns } from "./Deployed5GCDetailDialog.vue?vue&type=template&id=a72f5ece&scoped=true&"
import script from "./Deployed5GCDetailDialog.vue?vue&type=script&lang=js&"
export * from "./Deployed5GCDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./Deployed5GCDetailDialog.vue?vue&type=style&index=0&id=a72f5ece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72f5ece",
  null
  
)

export default component.exports